import { render, staticRenderFns } from "./DetailSaleReturn.vue?vue&type=template&id=00fa10c9"
import script from "./DetailSaleReturn.vue?vue&type=script&lang=js"
export * from "./DetailSaleReturn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports